export class TdoNoteQueryModel {
  patientId: string;
  parentObjectName: string;
  objectId: string;
  typeEnumId: string;
  categoryEnumId: string;
}
